/**
 * @file   src\mobile\components\SendIntroduction\IntroductionSuccessOffcanvas.js
 * @brief  This file is responsible for showing introduction send successfully
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { pageURLs } from "@/constants";
import { useNavigate } from "react-router-dom";

const IntroductionSuccessOffcanvas = (props) => {
  const { show, onHide } = props;
  const navigate = useNavigate();
  return (
    <Offcanvas
      className="mobile-offcanvas success-offcanvas"
      show={show}
      onHide={onHide}
      placement="bottom"
      {...props}
    >
      <Offcanvas.Body>
        <div className="success-wrap d-flex flex-column align-items-center justify-content-center">
          <div className="fireworks-overlay-top">
            <div className="pyro pyro-left-top">
              <div className="before"></div>
              <div className="after"></div>
            </div>
          </div>
          <i className="success-icon"></i>
          <h3>Introduction Sent!</h3>
          <p className="text-center">
            We’ll keep you updated on your introduction status. When they accept
            it, they’ll have 72 hours to send you a message. Good luck!
          </p>
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={() => {
              navigate(pageURLs?.mobileHome);
            }}
          >
            Close
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default IntroductionSuccessOffcanvas;
